import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {ProductService} from "../../services/product.service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'product-search',
    templateUrl: './search.component.html'
})
export class ProductSearchComponent implements OnInit {
    public products: Object[] = [];
    public query: string = '';
    public currentPage: number = 1;
    public totalPages: number = 0;
    public perPage: number = 10;
    public noProducts = false;
    public showLoader = true;
    public totalProducts: number = 0;

    constructor(private titleService: Title, private productService: ProductService, private route: ActivatedRoute, private router: Router) { }

    ngOnInit()
    {
	    
        this.get();
    }

    ngOnChanges()
    {
        this.get();
    }

    get()
    {
        this.titleService.setTitle('Dermabase - Zoeken');
        this.products = [];

        this.route.params.subscribe(params => {
            this.query = params['query'];
            this.titleService.setTitle('Dermabase - Zoeken: ' + this.query);

            this.productService.search(this.query, this.currentPage, this.perPage).subscribe((res) => {
//                if(res['data'] && res['data'].length == 1)
//                {
//                    this.goToProduct(res['data'][0], true);
//                }

                if(res['data'] && res['data'].length > 0)
                {
                    this.products = res['data'];
                    this.products.forEach(function(obj) {
                        obj['price'] = parseFloat(obj['Prijs'].replace(',','.'));
                    });
                    this.totalProducts = res['total'];
                    this.totalPages = Math.ceil(res['total']/this.perPage);
                    
                }
                

		        if(this.products.length <= 0){
			        this.noProducts = true;
		        }
		        
		        
				this.showLoader = false;
            });
            
            
        });
        
		
    }

    getIngredients(product)
    {
        return product['ingredients'].map(function(obj) {
            return obj['Ingredienten'];
        }).join(', ');
    }

    goToProduct(product, replaceUrl: boolean = false)
    {
        this.router.navigate(['product',product['id'],encodeURIComponent(product['Merk']+' '+product['Subnaam']).toLowerCase().replace(' ','-')], {replaceUrl});
    }

    changePage(pageNum: number)
    {
        this.currentPage = pageNum;
        this.get();
    }
}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/product/search.component.ts